import primaryComponents from "../../../primaryComponents";
import { usePOCategoriesForm } from "./usePOCategoriesForm";
import { useValidation } from "./useValidation";

export const POCategoriesForm = ({
  isEditMode = false,
  pOCategoryDetails = {},
  closeModal = () => {},
}) => {
  const { isLoading, formData, setFormData, handleCreateOrUpdateCategory } =
    usePOCategoriesForm({ pOCategoryDetails, isEditMode, closeModal });

  const {
    register,
    formState: { errors },
    trigger,
    control,
    handleSubmit,
  } = useValidation({ ...formData });

  return (
    <form>
      {/* Category name */}
      <primaryComponents.InputFieldV2
        name="name"
        control={control}
        label={"Category Name"}
        classNames="white"
        isRequired={true}
        register={register}
        placeholder="Enter your category name"
        type="text"
        errorMessage={errors.name}
        onKeyUp={() => errors.name !== undefined && trigger("name")}
        onChange={({ target: { value } }) => {
          setFormData((prev) => ({ ...prev, name: value }));
        }}
      />

      <primaryComponents.InputField
        label={"Category Description"}
        placeholder="Enter your category description"
        type="text"
        name="description"
        classNames="white"
        errorMessage={errors.description}
        onKeyUp={() =>
          errors.description !== undefined && trigger("description")
        }
        onChange={({ target: { value } }) => {
          setFormData((prev) => ({ ...prev, description: value }));
        }}
        register={register}
      />

      <primaryComponents.Button
        classNames={"btn btn--primary cover mt-4"}
        isDisabled={isLoading}
        isLoading={isLoading}
        loadingText={isEditMode ? "Updating..." : "Creating..."}
        type="button"
        onClick={handleSubmit(handleCreateOrUpdateCategory)}
      >
        {isEditMode ? "Update Category" : "Create Category"}
      </primaryComponents.Button>
    </form>
  );
};
